const CARD_SPACING = 200;

function calculateActionCardPosition(k, index, totalCards) {
    const HAND_Y = k.height() - 60;
    const totalWidth = (totalCards - 1) * CARD_SPACING;
    const HAND_START_X = k.width() / 2 - (totalWidth / 2);

    return k.vec2(HAND_START_X + (index * CARD_SPACING), HAND_Y);
}

export {
    calculateActionCardPosition,
}